export function isQueryAuthLossClearEnabled(): boolean {
  if (process.env.NEXT_PUBLIC_QUERY_AUTH_LOSS_CLEAR === 'false') {
    return false;
  }
  return true;
}
